import { formatMoney } from '../lib/format';

export default function PriceTag({
  price,
  currency,
  size = 'md',
}: {
  price: number;
  currency: string;
  size?: 'md' | 'lg';
}) {
  return (
    <span className={`font-bold text-white ${size === 'lg' ? 'text-2xl' : 'text-base'}`}>
      {formatMoney(price, currency)}
    </span>
  );
}
